<template>
    <b-row>
        <b-col>
            <b-form-group
                    :id="'input-group-typeFormation_' + trimestreIndex + '_' + posteIndex"
                    :label-for="'input-typeFormation_' + trimestreIndex + '_' + posteIndex">
                <template v-slot:label>
                    <label-custom
                            label="Type de formation"
                            tooltip="Indiquer le titre préparé et le niveau de formation"
                            :required="false">
                    </label-custom>
                </template>
                <b-form-select
                        :id="'input-typeFormation_' + trimestreIndex + '_' + posteIndex"
                        v-model="formation.type"
                        :options="typesFormation"
                        :disabled="disabled"
                        @change="typeFormationChange"
                        :state="getFieldState(true)">
                    <template v-slot:first>
                        <b-form-select-option :value="null">
                            Sélectionner un type de formation
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group :id="'input-group-duree' + trimestreIndex + '_' + posteIndex"
                          :label-for="'input-duree' + trimestreIndex + '_' + posteIndex">
                <template v-slot:label>
                    <label-custom
                            label="Durée"
                            tooltip="Indiquer le nombre d'heures"
                            :required="true">
                    </label-custom>
                </template>
                <b-form-input
                        :id="'input-duree' + trimestreIndex + '_' + posteIndex"
                        v-model="formation.duree"
                        type="number"
                        min="0"
                        step="any"
                        @input="emit"
                        :state="getFieldState(isFilledInput(formation.duree))"
                        :disabled="disabled || formation.type == null"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group :id="'input-group-nbInsertion' + trimestreIndex + '_' + posteIndex"
                          :label-for="'input-nbInsertion' + trimestreIndex + '_' + posteIndex">
                <template v-slot:label>
                    <label-custom
                            label="Nombre de personnes en insertion"
                            tooltip="Indiquer un nombre d’effectifs en équivalent temps plein"
                            :required="!nbInsertionDisabled">
                    </label-custom>
                </template>
                <b-form-input
                        :id="'input-nbInsertion' + trimestreIndex + '_' + posteIndex"
                        v-model="formation.nbInsertion"
                        type="number"
                        min="0"
                        step="any"
                        @input="emit"
                        :state="getFieldState(isFilledInput(formation.nbInsertion))"
                        :disabled="disabled || formation.type == null || nbInsertionDisabled"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group :id="'input-group-nbInsertionHorsInsertion' + trimestreIndex + '_' + posteIndex"
                          :label-for="'input-nbInsertionHorsInsertion' + trimestreIndex + '_' + posteIndex">
                <template v-slot:label>
                    <label-custom
                            label="Nombre de personnes hors insertion"
                            tooltip="Indiquer un nombre d’effectifs en équivalent temps plein"
                            :required="true">
                    </label-custom>
                </template>
                <b-form-input
                        :id="'input-nbInsertionHorsInsertion' + trimestreIndex + '_' + posteIndex"
                        v-model="formation.nbInsertionHorsInsertion"
                        type="number"
                        min="0"
                        step="any"
                        @input="emit"
                        :state="getFieldState(isFilledInput(formation.nbInsertionHorsInsertion))"
                        :disabled="disabled || formation.type == null"></b-form-input>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
  import FormationDto from "../../dtos/FormationDto";
  import LabelCustom from "../../components/LabelCustom";

  export default {
    name: "FormationGpec",
    props: ['value', 'trimestreIndex', 'posteIndex', 'typesFormation', 'disabled', 'formSubmitted', 'nbInsertionDisabled', 'posteTouched'],
    components: {LabelCustom},
    data() {
      return {
        formation: new FormationDto()
      }
    },
    watch: {
      value: function (val) {
        this.initFormation(val);
      }
    },
    mounted() {
      this.initFormation(this.value);
    },
    methods: {
      initFormation(val) {
        if (val) {
          this.formation = val;
        } else {
          this.formation = new FormationDto();
        }
      },
      getFieldState(fieldState) {
        return this.formSubmitted && this.posteTouched ? this.formation.type ? fieldState : true : null;
      },
      isFilledInput(value) {
        return value != null && value !== "";
      },
      typeFormationChange() {
        if (this.formation.type == null) {
          this.formation = new FormationDto();
        }
        this.emit();
      },
      emit() {
        const emittedValue = this.formation.type ? this.formation : null;
        this.$emit('input', emittedValue);
      }
    }
  };
</script>

